import React, { Component } from 'react'
import Iframe from 'react-iframe'
import { generateURLAffichage } from '../tools/fonctions'
import Filtre from '../components/layout/Filtre'
import { subscribe, unsubscribe } from '../tools/eventDispatcher'

import { collection, getDocs } from 'firebase/firestore'
import { db } from '../config/fbConfig'

class AffichageRapport extends Component {

    state = {
        METABASE_KEY: '',
        url: null,
        error: null,
        nomRapport: null,
        Secteur: null,
        Agence: null
    }

    async componentDidMount() {
        try {
            const snapshot = await getDocs(collection(db, 'metabase'))
            let metabaseKey = ''

            snapshot.forEach(doc => {
                metabaseKey = doc.data().key
            })

            this.setState(
                { METABASE_KEY: metabaseKey },
                () => this.generateURL()
            )
        } catch (error) {
            this.setState({ error })
        }

        subscribe('localStorageChange', this.handleStorageChange)
    }

    componentWillUnmount() {
        unsubscribe('localStorageChange', this.handleStorageChange)
    }

    handleStorageChange = ({ key, value }) => {
        if (key === 'localStorage') {
            const { nomRapport, Secteur, Agence } = value

            if (
                nomRapport !== this.state.nomRapport ||
                Secteur !== this.state.Secteur ||
                Agence !== this.state.Agence
            ) {
                this.setState(
                    { nomRapport, Secteur, Agence },
                    () => this.generateURL()
                )
            }
        }
    }

    generateURL() {
        const {
            nomRapport,
            typeRapport,
            numRapport,
            Secteur,
            Agence,
            dateDeb,
            dateFin,
            nomParamSecteur,
            nomParamAgence,
            dateParamDeb,
            dateParamFin
        } = window.localStorage

        if (nomRapport && this.state.METABASE_KEY) {
            generateURLAffichage(
                typeRapport,
                numRapport,
                Secteur,
                Agence,
                dateDeb,
                dateFin,
                nomParamSecteur,
                nomParamAgence,
                dateParamDeb,
                dateParamFin,
                this.state.METABASE_KEY
            )
                .then(url => this.setState({ url, error: null }))
                .catch(error => this.setState({ error }))
        }
    }

    render() {
        const { url, error, METABASE_KEY } = this.state

        return (
            <div className="rapport m-0 bg-white w-100 d-inline-block">
                <Filtre />

                {error && <div className="error">Erreur : {error.message}</div>}

                {!url && !error && <div className="loading">Chargement...</div>}

                {url && (
                    <Iframe
                        url={url}
                        position="absolute"
                        width="100%"
                        height="86.8%"
                        top="0"
                        left="0"
                        frameBorder="0"
                    />
                )}

                {!url && !error && !window.localStorage.nomRapport && !METABASE_KEY && (
                    <div className="no-rapport">Veuillez sélectionner un rapport</div>
                )}
            </div>
        )
    }
}

export default AffichageRapport
